<template>
  <div>
    <div class="d-none d-md-block pa-4 pa-md-2">
      <Breadcrumbs
        headline="Giáo viên"
        :link="[{ text: 'Giáo viên', href: '../teachers' }]"
      />
    </div>

    <v-card class="pa-2 mx-md-2">
      <teacher-profile :teacher="teacherDetail"></teacher-profile>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TeacherProfile from '@/modules/teacher/profile/TeacherProfile'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
export default {
  components: {
    TeacherProfile,
    Breadcrumbs,
  },
  computed: {
    ...mapGetters('teacher', ['teacher', 'teacherDetail']),
    teacherInfo() {
      return this.teacher(this.$route.params.id) || {}
    },
  },
  data() {
    return {
      tab: null,
      avatar: {},
    }
  },
  async created() {
    await this.fetchTeacher(this.$route.params.id)
  },
  methods: {
    ...mapActions('teacher', [
      'updateTeacher',
      'fetchTeacher',
      'removeTeacher',
    ]),
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    cancel() {
      this.state = false
    },
  },
}
</script>
